'use client';

import { researchPlatformListingSection } from '@stereoagency/sanity-schema';
import { useContext } from 'react';
import useSWR from 'swr';
import { researchPlatformsQuery } from './researchPlatformsQuery';
import ResearchPlatformListingSection from './ResearchPlatformListingSection.client';
import { SanityDraftClientContext } from '@/components/context';

type Props = Omit<
  typeof researchPlatformListingSection.schema.researchPlatformListingSection,
  '_type'
> & {};

export default function DraftModeResearchGroupListingSection({
  enableTaxonomyFilter,
  staticFilter,
  hideCardImages
}: Props) {
  const { client } = useContext(SanityDraftClientContext);
  const { data } = useSWR('researchPlatforms', () =>
    client?.fetch<(typeof researchPlatformsQuery)[1]>(
      researchPlatformsQuery[0],
      { taxonomies: staticFilter?.map((tax) => tax._ref) ?? [] }
    )
  );

  return (
    <ResearchPlatformListingSection
      hideCardImages={hideCardImages}
      enableTaxonomyFilter={enableTaxonomyFilter}
      platforms={data ?? []}
    />
  );
}
